<div class="container-fluid mt-4">
  <!-- Main Card Container -->
  <div class="card attendance-dashboard-card">
    <!-- Card Header with Title and Filters -->
    <div class="card-header">
      <div class="row align-items-center">
        <div class="col-md-6">
          <div class="header-title">
            <h2 class="mb-0 text-Black">
              Employee Attendance - {{ attendanceList[0]?.employee_name }}
            </h2>
            <p class="subtitle mb-0 text-Black">
              Track and manage employee attendance records
            </p>
            <!-- Defined Work Times Display -->
            <div class="defined-work-times mt-2" *ngIf="attendanceList[0]?.defined_work_in_time && attendanceList[0]?.defined_work_out_time">
              <small class="text-Black">
                <strong>Defined Work Schedule:</strong> 
                {{ attendanceList[0]?.defined_work_in_time }} to {{ attendanceList[0]?.defined_work_out_time }}
              </small>
            </div>
            <div class="defined-work-times mt-2" *ngIf="!attendanceList[0]?.defined_work_in_time || !attendanceList[0]?.defined_work_out_time">
              <small class="text-warning">
                <strong>Work schedule not defined</strong>
              </small>
            </div>
          </div>
        </div>
        <div class="col-md-6 d-flex justify-content-end align-items-center">
  <div class="date-range-field">
    <mat-form-field appearance="fill">
      <mat-label>Enter a date range</mat-label>
<mat-date-range-input [formGroup]="range" [rangePicker]="picker" [max]="maxDate">
        <input
          matStartDate
          formControlName="start"
          placeholder="Start date"
        />
        <input
          matEndDate
          formControlName="end"
          placeholder="End date"
        />
      </mat-date-range-input>
      <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle
        matSuffix
        [for]="picker"
      ></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  </div>
  
  <button class="btn btn-primary ms-2" (click)="fetchReportData()">
    Apply
  </button>
</div>
      </div>
    </div>

    <!-- Card Body with Attendance Data -->
    <div class="card-body">
      <!-- Loading Message -->
      <div *ngIf="isLoading" class="alert alert-info text-center">
        <div class="spinner-border spinner-border-sm me-2" role="status"></div>
        Loading attendance data...
      </div>

      <!-- No Data Message -->
      <div *ngIf="!isLoading && attendanceList.length === 0" class="alert alert-warning text-center">
        No attendance data found for the selected criteria.
      </div>

      <!-- Active Filter Indicator -->
      <div *ngIf="!isLoading && attendanceList.length > 0 && currentFilter !== 'all'" 
           class="alert alert-info d-flex justify-content-between align-items-center">
        <div>
          <i class="fas fa-filter me-2"></i>
          {{ getActiveFilterText() }}
        </div>
        <button class="btn btn-sm btn-outline-secondary" (click)="filterRecords('all')">
          <i class="fas fa-times me-1"></i> Clear Filter
        </button>
      </div>

      <!-- Summary Stats -->
      <div class="summary-stats mb-4" *ngIf="!isLoading && attendanceList.length > 0">
        <div class="row">
          <div class="col-md-3">
            <div class="stat-card" 
                 [class.active]="isFilterActive('all')"
                 (click)="filterRecords('all')">
              <div class="stat-value">{{ attendancePercentage }}%</div>
              <div class="stat-label">Overall Attendance</div>
              <div class="stat-progress">
                <div
                  class="progress-bar bg-success"
                  [style.width.%]="attendancePercentage"
                ></div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="stat-card" 
                 [class.active]="isFilterActive('all')"
                 (click)="filterRecords('all')">
              <div class="stat-value">{{ absentPercentage }}%</div>
              <div class="stat-label">Absent Rate</div>
              <div class="stat-progress">
                <div
                  class="progress-bar bg-danger"
                  [style.width.%]="absentPercentage"
                ></div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="stat-card clickable" 
                 [class.active]="isFilterActive('present')"
                 (click)="filterRecords('present')">
              <div class="stat-value">{{ fullDayCount }} Days</div>
              <div class="stat-label">Present days</div>
              <div class="stat-progress">
                <div
                  class="progress-bar bg-secondary"
                  [style.width.%]="getProgressPercentage(fullDayCount)"
                ></div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="stat-card clickable" 
                 [class.active]="isFilterActive('absent')"
                 (click)="filterRecords('absent')">
              <div class="stat-value">{{ absentCount }} Days</div>
              <div class="stat-label">Absent Days</div>
              <div class="stat-progress">
                <div
                  class="progress-bar bg-warning"
                  [style.width.%]="getProgressPercentage(absentCount)"
                ></div>
              </div>
            </div>
          </div>
          <!-- Clickable Leave Type Stats -->
          <div class="col-md-3">
            <div class="stat-card clickable" 
                 [class.active]="isFilterActive('sick')"
                 (click)="filterRecords('sick')">
              <div class="stat-value">{{ sickLeaveCount }} Days</div>
              <div class="stat-label">Sick Leave</div>
              <div class="stat-progress">
                <div
                  class="progress-bar bg-danger"
                  [style.width.%]="getProgressPercentage(sickLeaveCount)"
                ></div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="stat-card clickable" 
                 [class.active]="isFilterActive('local')"
                 (click)="filterRecords('local')">
              <div class="stat-value">{{ localLeaveCount }} Days</div>
              <div class="stat-label">Local Leave</div>
              <div class="stat-progress">
                <div
                  class="progress-bar bg-warning"
                  [style.width.%]="getProgressPercentage(localLeaveCount)"
                ></div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="stat-card clickable" 
                 [class.active]="isFilterActive('vacation')"
                 (click)="filterRecords('vacation')">
              <div class="stat-value">{{ vacationCount }} Days</div>
              <div class="stat-label">Vacation Leave</div>
              <div class="stat-progress">
                <div
                  class="progress-bar bg-info"
                  [style.width.%]="getProgressPercentage(vacationCount)"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Attendance Table -->
      <div class="table-responsive" *ngIf="!isLoading && filteredAttendanceList.length > 0">
        <table class="table attendance-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Department</th>
              <th>Work In</th>
              <th>Break Out</th>
              <th>Break In</th>
              <th>Work Out</th>
              <th>Worked Hours</th>
              <th>Overtime Hours</th>
              <th>Status</th>
              <th>Reason</th>
              <th>Leave Type</th>
              <th>Adjusted</th>
              <th>HR Approval</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredAttendanceList">
              <td>
                {{ item.date | date }}
              </td>
              <td>{{ item?.department }}</td>
              <td>
                {{ extractTimeValue(item?.work_in) }}
              </td>
              <td>
      <div *ngIf="hasBreakData(item?.break_out)" class="break-times">
        <div *ngFor="let breakTime of getBreakTimes(item?.break_out)" 
             class="break-time-item">
          {{ breakTime }}
        </div>
      </div>
      <span *ngIf="!hasBreakData(item?.break_out)" class="text-muted">-</span>
    </td>
              <td>
      <div *ngIf="hasBreakData(item?.break_in)" class="break-times">
        <div *ngFor="let breakTime of getBreakTimes(item?.break_in)" 
             class="break-time-item">
          {{ breakTime }}
        </div>
      </div>
      <span *ngIf="!hasBreakData(item?.break_in)" class="text-muted">-</span>
    </td>
              <td>
                {{ extractTimeValue(item?.work_out) }}
              </td>
              <td>
                {{ extractTimeValue(item?.total_worked_hours) }}
              </td>
              <td>
                <span *ngIf="item?.total_overtime_hours && item?.total_overtime_hours !== '00:00'; else noOvertime">
                  {{ formatOvertimeHours(item.total_overtime_hours) }}
                </span>
                <ng-template #noOvertime>
                  <span class="text-muted">-</span>
                </ng-template>
              </td>
              <td>
                <span [ngClass]="'badge ' + getStatusBadgeClass(item)">
                  {{ getDisplayStatus(item) }}
                </span>
              </td>
              <td> 
                <span
                   [ngClass]=" item?.statusMessage ? 'text-dark' : 'text-muted' "> {{ item.statusMessage || "" }} 
                </span> 
              </td>
          <td>
  <span
    [ngClass]="
      'badge ' +
      ((item?.leave_type || '').trim().toLowerCase() === 'sick leave'
        ? 'bg-primary'
        : (item?.leave_type || '').trim().toLowerCase() === 'local leave'
        ? 'bg-primary'
        : (item?.leave_type || '').trim().toLowerCase() === 'vacation'
        ? 'bg-primary'
        : (item?.leave_type || '').trim().toLowerCase() === 'annual leave'
        ? 'bg-primary'
        : (item?.leave_type || '').trim().toLowerCase() === 'casual leave'
        ? 'bg-primary'
        : 'bg-light text-dark')
    "
  >
    {{ item?.leave_type || "-" }}
  </span>
</td>
              <td>{{ item?.has_adjustment }}</td>
              <td>{{ item?.leave_status || "-" }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- No Filtered Data Message -->
      <div *ngIf="!isLoading && attendanceList.length > 0 && filteredAttendanceList.length === 0" 
           class="alert alert-warning text-center">
        No records found for the current filter.
      </div>
    </div>
  </div>
</div>

<!-- Edit Attendance Modal -->
<div
  class="modal fade"
  id="editAttendanceModal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-calendar-check me-2"></i>
          Edit Attendance Record
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <form>
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">Date</label>
              <input type="date" class="form-control" value="2025-06-02" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Employee</label>
              <input
                type="text"
                class="form-control"
                value="Ali Mohammed"
                readonly
              />
            </div>
            <div class="col-md-3">
              <label class="form-label">Work In</label>
              <input type="time" class="form-control" value="08:10" />
            </div>
            <div class="col-md-3">
              <label class="form-label">Break Out</label>
              <input type="time" class="form-control" />
            </div>
            <div class="col-md-3">
              <label class="form-label">Break In</label>
              <input type="time" class="form-control" />
            </div>
            <div class="col-md-3">
              <label class="form-label">Work Out</label>
              <input type="time" class="form-control" value="19:10" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Status</label>
              <select class="form-select">
                <option>Full Day</option>
                <option>Half Day</option>
                <option selected>Absent</option>
                <option>Leave</option>
              </select>
            </div>
            <div class="col-md-6">
              <label class="form-label">Leave Type</label>
              <select class="form-select">
                <option selected>None</option>
                <option>Annual Leave (AL)</option>
                <option>Casual Leave (CL)</option>
                <option>Sick Leave (SL)</option>
              </select>
            </div>
            <div class="col-12">
              <label class="form-label">Remarks</label>
              <textarea class="form-control" rows="3"></textarea>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          data-bs-dismiss="modal"
        >
          Cancel
        </button>
        <button type="button" class="btn btn-primary">Save Changes</button>
      </div>
    </div>
  </div>
</div>